import React, { Component } from 'react';
import PropTypes from 'prop-types';

import moment from 'moment-timezone';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import { urlToId } from 'utils/converters';

import {
  fetchRecurringOrder,
  openRecurringOrderDetailModal,
} from 'redux/modules/recurring-orders/effects';
import { getRecurringOrder } from 'redux/modules/recurring-orders/selectors';

import WeekDays from 'modules/recurring-orders/WeekDays';

import { Spacer, Link } from '@ontruck/orc';

const t = {
  recurring_config_link: 'View recurring configuration for all orders',
  rule: 'Repeats every {days} until {date} ',
};

class RecurringInfo extends Component {
  constructor(props) {
    super(props);

    this.openRecurringOrderDetailModal = this.openRecurringOrderDetailModal.bind(this);
  }

  componentDidMount() {
    const { item, fetchRecurringOrder } = this.props;

    if (this.isShipperOrderFromRecurring()) {
      fetchRecurringOrder({ id: urlToId(item.recurring_order) });
    }
  }

  isShipperOrderFromRecurring() {
    const { item } = this.props;
    return item && !!item.recurring_order;
  }

  openRecurringOrderDetailModal() {
    const { recurringOrder, item, openRecurringOrderDetailModal } = this.props;

    return openRecurringOrderDetailModal({
      id: item?.recurring_order ? urlToId(item.recurring_order) : recurringOrder.id,
    });
  }

  render() {
    const { recurringOrder } = this.props;
    if (!this.isShipperOrderFromRecurring()) {
      return null;
    }

    return (
      <>
        {recurringOrder && (
          <Spacer mRight="L">
            <strong>
              <FormattedMessage
                id="so-ro-rule"
                defaultMessage={t.rule}
                values={{
                  days: <WeekDays isoDays={recurringOrder.schedule} />,
                  date: moment(recurringOrder.end_on).format('MMM DD'),
                }}
              />
            </strong>
          </Spacer>
        )}
        {recurringOrder && (
          <Link
            skin="secondary"
            text={t.recurring_config_link}
            onClick={this.openRecurringOrderDetailModal}
          />
        )}
      </>
    );
  }
}

RecurringInfo.propTypes = {
  item: PropTypes.object,
  fetchRecurringOrder: PropTypes.func.isRequired,
  openRecurringOrderDetailModal: PropTypes.func.isRequired,
  recurringOrder: PropTypes.shape({}),
};

RecurringInfo.defaultProps = {
  item: {},
};

const mapStateToProps = (state) => ({
  recurringOrder: getRecurringOrder(state),
});

const mapDispatchToProps = {
  fetchRecurringOrder,
  openRecurringOrderDetailModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(RecurringInfo);
